<div class="modal-header">
  <h4 class="modal-title mt-0" id="modal-title" translate>SPLIT_PARCEL_PRODUCT</h4>
  <button type="button" class="close" aria-describedby="modal-title" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="row">
    <div class="col-12">
      <div class="parcel-management-dragdrop-list-container mb-3">
        <div class="parcel-management-dragdrop-list-header">
          <h4>{{ 'SPLIT_RESULT' | translate }}</h4>
          <button class="btn btn-sm btn-primary" (click)="addRow()">{{ 'ADD_ROW' | translate }}</button>
        </div>

        @for (item of resultParcelProducts; track item.tempId; let i = $index) {
          <div class="parcel-management-dragdrop-list-item">
            <div class="list-item-image">
              <img
                class="img-fluid"
                *ngIf="product?.extra?.images?.length > 0"
                [src]="product.extra.images[0].s3Uri
                  | gungImageUrl
                    :'type:thumbnail'
                    :'etag:' + product.extra.images[0].s3ETag"
                alt=""
              />
            </div>

            <div class="list-item-id">
              <span>{{ 'ID' | translate }}: {{ item.ids?.gungId }}</span>
              @if (item.ids?.ean13) {
                <br />
                <span>{{ 'EAN' | translate }}: {{ item.ids?.ean13 }}</span>
              }
            </div>

            <div class="list-item-name">{{ item.name }}</div>

            <div class="list-item-quantity">
              <input class="form-control" type="number" [(ngModel)]="item.quantity" (ngModelChange)="checkQuantities()" [min]="0" [max]="parcelProduct.quantity">
            </div>

            <div class="action-buttons">
              <button class="btn btn-sm btn-outline-primary" (click)="removeRow(i)"><i class="fa-regular fa-trash"></i></button>
            </div>
          </div>
        }
      </div>

      @if (tooManyQuantities) {
        <div class="alert alert-warning mb-0">
          {{ 'THERE_ARE_TOO_MANY_ASSIGNED_QUANTITIES' | translate }}
        </div>
      }

      @if (unassignedQuantities) {
        <div class="alert alert-warning mb-0">
          {{ 'THERE_ARE_UNASSIGNED_QUANTITIES' | translate }}
        </div>
      }
    </div>
  </div>
</div>

<div class="modal-footer">
  <div class="row w-100">
    <div class="col d-flex align-items-center">
       {{ 'UNASSIGNED_QUANTITIES' | translate }}: {{ unassignedQty }}
    </div>
    <div class="col d-flex justify-content-end">
      <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss()" translate>CANCEL</button>
      <button type="button" class="btn btn-primary btn-sm ml-2" (click)="split()" [disabled]="tooManyQuantities || unassignedQuantities" translate>SPLIT</button>
    </div>
  </div>
</div>
